import React from "react";
import { Card, Table, Typography, Image, Row, Col } from "antd";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from "recharts";

const { Title, Text } = Typography;

const ProductReport = ({ productData, performanceData }) => {
  console.log(productData);
  console.log(performanceData);
  // Format data for Recharts
  const pieData =
    productData?.bestSellingProducts?.map((product) => ({
      name: product.productName,
      value: product.totalQuantity,
    })) || [];

  // Custom colors for the pie chart
  const COLORS = [
    "#0088FE",
    "#00C49F",
    "#FFBB28",
    "#FF8042",
    "#8884d8",
    "#83a6ed",
    "#8dd1e1",
  ];

  const columns = [
    {
      title: "Product",
      dataIndex: "productName",
      key: "name",
      render: (text, record) => (
        <div className="flex items-center">
          <Image
            src={record.image}
            width={50}
            height={50}
            className="rounded mr-3"
            preview={false}
            // fallback="https://via.placeholder.com/50"
          />
          <Text strong>{text}</Text>
        </div>
      ),
    },
    {
      title: "Sold",
      dataIndex: "totalSold",
      key: "sold",
      sorter: (a, b) => a.totalQuantity - b.totalQuantity,
    },
    {
      title: "Revenue",
      dataIndex: "totalRevenue",
      key: "revenue",
      render: (amount) => `$${amount.toFixed(2)}`,
      sorter: (a, b) => a.totalRevenue - b.totalRevenue,
    },
  ];

  return (
    <div className="space-y-4">
      <Row gutter={16}>
        <Col span={12}>
          <Card title="Best Selling Products">
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={pieData}
                  cx="50%"
                  cy="50%"
                  labelLine={true}
                  outerRadius={80}
                  fill="#8884d8"
                  dataKey="value"
                  label={({ name, percent }) =>
                    `${name} ${(percent * 100).toFixed(0)}%`
                  }
                >
                  {pieData.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))}
                </Pie>
                <Tooltip
                  formatter={(value) => [`${value} units`, "Quantity"]}
                />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </Card>
        </Col>
        <Col span={12}>
          <Card title="Product Performance">
            <Table
              columns={columns}
              dataSource={performanceData || []}
              rowKey="productId"
              pagination={false}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ProductReport;
